import React, { useEffect, useState, useContext, useCallback } from "react";
import { FormRow } from "components/CustomComponents/FormRow";
import { ATCONSTANTS as ATC } from "appconstants";
import bindLogger from "helpers/BindLogger";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { AppContext } from "@ctsu/loader";
import { getProtocolVersions, clearProtocolVersions } from "actions/cirb";
import { getProtocolPSR, clearProtocolPSR } from "actions/common";
import { CopyPastePaginateElement } from "components/EmailGenerator/CopyPasteElements";
import _ from "lodash";

function PacketCopyPaste(props) {
  const {
    packetId,
    indexingRows,
    protocolVersions,
    psr,
    protVersions,
    clearProtocolPSRAc,
    clearProtocolVersionsAc,
    fetchProtocolPSR,
  } = props;
  const context = useContext(AppContext);
  const [indexArray, setIndexArray] = useState([]);
  const [data, setData] = useState({
    packetId: null,
    siteName: null,
    siteCtepId: null,
    fwa: null,
    expiryDate: null,
    protocol: null,
    version: null,
    versionDate: null,
    versionDesc: null,
    psr: null,
    psrDesc: null,
    verifiedBy: null,
    requiredByDate: null,
  });

  const getCopyPasteVersions = useCallback(
    (protocol) => {
      const postBody = {
        isMetaRequired: false,
        sort: [{ field: "versionDate", value: "asc" }],
      };
      bindLogger(protVersions, context)(protocol, postBody);
    },
    [protVersions, context]
  );

  const getCopyPastePsr = useCallback(
    (protocol) => {
      bindLogger(fetchProtocolPSR, context)(protocol);
    },
    [fetchProtocolPSR, context]
  );

  const updateIndex = useCallback(
    (rec) => {
      setData((d) => ({
        ...d,
        packetId,
        siteName: rec.siteName,
        siteCtepId: rec.siteCtepId,
        protocol: rec.protocolNumber || null,
        fwa: rec.ohrpAssuranceNbr || null,
        expiryDate: rec.ohrpExpirationDate || null,
      }));
      if (rec.protocolNumber != null) {
        getCopyPasteVersions(rec.protocolNumber);
        getCopyPastePsr(rec.protocolNumber);
      }
    },
    [getCopyPasteVersions, getCopyPastePsr, packetId]
  );

  const sortIndexRows = (rows) => _.sortBy(rows, [(obj) => obj.siteCtepId]);

  useEffect(() => {
    if (indexingRows != null && indexingRows.length > 0) {
      let indexArr = _.cloneDeep(indexingRows);
      indexArr = sortIndexRows(indexArr);
      const rec = indexArr[0];
      setIndexArray(indexArr);
      updateIndex(rec);
    } else {
      setData((d) => ({
        ...d,
        packetId,
      }));
    }
  }, [packetId, indexingRows, updateIndex]);

  useEffect(() => {
    let obj = null;
    if (protocolVersions != null && protocolVersions.length > 0) {
      const rec = protocolVersions[0];
      obj = {
        ...obj,
        version: rec.versionNo,
        versionDate: rec.versionDate,
        versionDesc: rec.versionDesc,
        requiredByDate: rec.requiredByDate,
      };
    }
    if (psr != null && psr.length > 0) {
      const rec = psr[0];
      obj = {
        ...obj,
        psr: rec.code,
        psrDesc: rec.description,
        verifiedBy: rec.verifiedBy,
        requiredByDate: rec.requiredByDate,
      };
    }
    if (obj != null) {
      setData((d) => ({
        ...d,
        ...obj,
      }));
    }
  }, [protocolVersions, psr]);

  useEffect(
    () => () => {
      setIndexArray([]);
      clearProtocolVersionsAc();
      clearProtocolPSRAc();
    },
    [clearProtocolVersionsAc, clearProtocolPSRAc]
  );

  const changePsr = (arr, i) => {
    const rec = arr != null && arr[i - 1];
    if (rec) {
      setData((d) => ({
        ...d,
        psr: rec.code,
        psrDesc: rec.description,
        verifiedBy: rec.verifiedBy,
        requiredByDate: rec.requiredByDate,
      }));
    }
  };

  const changeVersion = (arr, i) => {
    const rec = arr != null && arr[i - 1];
    if (rec) {
      setData((d) => ({
        ...d,
        version: rec.versionNo,
        versionDate: rec.versionDate,
        versionDesc: rec.versionDesc,
      }));
    }
  };

  const changeIndex = (arr, i) => {
    const rec = arr != null && arr[i - 1];
    if (rec) {
      updateIndex(rec);
      changeVersion(rec)
    }
  };

  return (
    <>
      <div className="m-2">
        <FormRow
          dataId={`${ATC.APP}PACKET_ID${ATC.TEXT}`}
          value={data.packetId}
          label="Pkt ID"
          name="pktId"
          readOnly
        />
      </div>
      <div className="m-2">
        <CopyPastePaginateElement
          data={indexArray}
          input={{
            value: data.siteCtepId
              ? `${data.siteName} (${data.siteCtepId})`
              : "No data found",
            label: "SITE INDEX",
            name: "siteIndex",
            id: "SITE_INDEX",
          }}
          changeEvent={changeIndex}
        />
      </div>
      <div className="m-2">
        <FormRow
          dataId={`${ATC.APP}FWA${ATC.TEXT}`}
          value={`${data.fwa} (${data.expiryDate})`}
          label=""
          name="fwaDetails"
          readOnly
        />
      </div>
      <hr />
      <div className="m-2">
        <FormRow
          dataId={`${ATC.APP}PROTOCOL${ATC.TEXT}`}
          value={data.protocol || "No data found"}
          label="Protocol"
          name="protocol"
          readOnly
        />
      </div>
      <div className="m-2">
        <CopyPastePaginateElement
          allowReset
          data={protocolVersions}
          input={{
            value: data.version
              ? `${data.versionDate} (Version ${data.version})`
              : "No data found",
            label: "Version",
            name: "version",
            id: "VERSION",
          }}
          changeEvent={changeVersion}
        />
      </div>
      <div className="m-2">
        <FormRow
          dataId={`${ATC.APP}VERSION_DESC${ATC.TEXT}`}
          value={data.versionDesc || "No data found"}
          label="Version Desc"
          name="versionDesc"
          readOnly
        />
      </div>
      <hr />
      <div className="m-2">
        <CopyPastePaginateElement
          allowReset
          data={psr}
          input={{
            value: data.psr ? `${data.psrDesc} (${data.psr})` : "No data found",
            label: "PSR",
            name: "psr",
            id: "PSR",
          }}
          changeEvent={changePsr}
        />
      </div>
      <div className="m-2">
        <FormRow
          dataId={`${ATC.APP}PSR_VERIFIED_BY${ATC.TEXT}`}
          value={data.verifiedBy || "No data found"}
          label="VerifiedBy"
          name="verifiedBy"
          readOnly
        />
      </div>
      <div className="m-2">
        <FormRow
          dataId={`${ATC.APP}PSR_REQUIRED_BY_DATE${ATC.TEXT}`}
          value={data.requiredByDate || "No data found"}
          label="Required By Date"
          name="requiredByDate"
          readOnly
        />
      </div>
    </>
  );
}

const mapStateToProps = (state) => ({
  indexingRows: state.packet.indexing,
  protocolVersions: state.cirb.protocolVersions,
  psr: state.email.psr,
});

const withConnectState = connect(mapStateToProps, (dispatch) =>
  bindActionCreators(
    {
      protVersions: getProtocolVersions,
      clearProtocolVersionsAc: clearProtocolVersions,
      fetchProtocolPSR: getProtocolPSR,
      clearProtocolPSRAc: clearProtocolPSR,
    },
    dispatch
  )
);

export default withConnectState(PacketCopyPaste);
